/**
 * Financial Profiles API Endpoints
 * Profile reconciliation (declared vs detected expenses)
 */

import apiClient from '../client';
import type {
  ReconciliationResponse,
  ReconcileCategoryResponse,
} from '../types';

export const financialProfilesApi = {
  /**
   * GET /financial_profiles/reconciliation
   * Compare declared expenses vs detected from transactions
   */
  getReconciliation: async (): Promise<ReconciliationResponse> => {
    const response = await apiClient.get<ReconciliationResponse>(
      '/financial_profiles/reconciliation',
    );
    return response.data;
  },

  /**
   * PATCH /financial_profiles/reconcile_category
   * Update a single category in the expenses breakdown
   */
  reconcileCategory: async (
    category: string,
    amount: number,
  ): Promise<ReconcileCategoryResponse> => {
    const response = await apiClient.patch<ReconcileCategoryResponse>(
      '/financial_profiles/reconcile_category',
      { category, amount },
    );
    return response.data;
  },
};
